export default __webpack_public_path__ + "static/media/add-resource-disabled.52f55df1.svg";